/**
 * TrialCountdown - Trial banner for header
 * Uses Tailwind CSS for styling - NO CUSTOM CSS FILES
 */
import React from 'react';
import i18n from '../../i18n/i18n';
import { tr } from '../../i18n/i18n';

export interface TrialCountdownProps {
  daysRemaining: number | null | undefined;
  onUpgradeClick: () => void;
}

const TrialCountdown: React.FC<TrialCountdownProps> = ({ daysRemaining, onUpgradeClick }) => {
  const getMessage = () => {
    if (daysRemaining === null || daysRemaining === undefined || daysRemaining <= 0) {
      return tr('g.trial_expires_today', 'Trial expires today');
    } else if (daysRemaining === 1) {
      return tr('g.one_day_left_in_trial', '1 day left in trial');
    } else {
      return tr('g.days_left_in_trial', '{{count}} days left in trial').replace(
        '{{count}}',
        String(daysRemaining),
      );
    }
  };

  const getSeverityClasses = () => {
    if (!daysRemaining || daysRemaining <= 2) {
      return 'bg-red-100 text-red-800 border-red-300';
    }
    if (daysRemaining <= 5) {
      return 'bg-amber-100 text-amber-800 border-amber-300';
    }
    return 'bg-blue-100 text-blue-800 border-blue-300';
  };

  return (
    <div
      className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 border ${getSeverityClasses()}`}
    >
      {/* Clock Icon */}
      <div className="flex items-center justify-center flex-shrink-0">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M8 2V8L11 11"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5" fill="none" />
        </svg>
      </div>

      <span className="whitespace-nowrap font-semibold hidden sm:inline">{getMessage()}</span>

      <button
        className="bg-purple-600 text-white border-none rounded px-3 py-1 text-xs font-semibold cursor-pointer transition-colors duration-200 whitespace-nowrap hover:bg-purple-700 active:bg-purple-800"
        onClick={onUpgradeClick}
      >{tr('g.upgrade_now', 'Upgrade Now')}</button>
    </div>
  );
};

export default TrialCountdown;
